module.exports = __webpack_public_path__ + "static/media/userprofile.7a21cbe9.svg";